import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { onThemePropChange } from '../../../helpers/ThemeStoreHelpers';
import { RemFilter } from '../../../helpers/RemFilter';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import BackgroundPicker from '../../../widgets/BackgroundPicker';
import FontConfigurator from '../../../widgets/FontConfigurator/FontConfigurator';
import CSSLength from '../../../../../lib/css-property-parser/CSSLength';
import { get } from 'lodash';

const prefix = 'buttons.button';

const LEVELS = {
    NORMAL: 'normal',
    HOVER: 'hover',
    ACTIVE: 'active'
};

const TITLES = {
    BACKGROUND: 'BACKGROUND',
    FONT: 'FONT'
};

const FontPropertySelect = ({ label, values, defaultValue, onChange, isDisabled }) => {
    return (
        <div>
            <ReactSparkSelectInput
                label={label}
                onChange={onChange}
                defaultValue={defaultValue}
                isDisabled={isDisabled}
                values={values.map(v => {
                    return { key: v.toString(), label: v.toString() };
                })}
            />
        </div>
    );
};

class ButtonStyles extends Component {
    static defaultProps = {
        availableFontFamilies: {}
    };

    renderBackgroundPicker({ title, level }) {
        const background = get(this.props.data, `background.${level}`, '');

        return (
            <div>
                <div>
                    {title}
                </div>
                <div>
                    <BackgroundPicker
                        background={background}
                        preset={this.props.themeColors.primary.colors}
                        isDisabled={this.props.isDisabled}
                        onChange={property =>
                            this.props.onBackgroundColorChange(
                                this.props.layer,
                                this.props.tagName,
                                level
                            )({
                                target: {
                                    value: property
                                }
                            })
                        }
                    />
                </div>
            </div>
        );
    };

    renderFontPicker({ level }) {
        const color = get(this.props.data, `color.${level}`, '');

        return (
            <div>
                <div>{TITLES.FONT}</div>
                <div>
                    <PresetColorPicker
                        color={color}
                        isDisabled={this.props.isDisabled}
                        onColorChange={this.props.onFontColorChange(
                            this.props.layer,
                            this.props.tagName,
                            level
                        )}
                    />
                </div>
            </div>
        );
    };

    render() {
        const borderNormal = this.props.data.border.normal.split(' ');
        const borderHover = this.props.data.border.hover.split(' ');
        const borderActive = this.props.layer === 'primary' ? this.props.data.border.active.split(' ') : null;
        const fontSize = new CSSLength(this.props.data.fontSize, {
            base: 16,
            formatter: (value, unit) => value + unit
        });
        const borderRadius = new CSSLength(this.props.data.borderRadius, {
            base: 16,
            formatter: (value, unit) => value + unit
        });
        const fontSize2 = fontSize.px;
        const fontSize3 = `${Math.round(fontSize2.substring(0, fontSize2.length - 2))}px`;
        const borderRadius2 = borderRadius.px;
        const borderRadius3 = `${Math.round(borderRadius2.substring(0, borderRadius2.length - 2))}px`;
        return (
            <div className="ButtonStyles">
                <div
                    className="row"
                    style={{
                        marginBottom: '25px'
                    }}
                >
                    <div className="col-lg-3 col-xs-12 col-sm-8">
                        <div className="row">
                            <div className="col-md-6 col-xs-6" style={{ marginBottom: '25px' }}>
                                {this.renderBackgroundPicker({
                                    level: LEVELS.NORMAL,
                                    title: TITLES.BACKGROUND
                                })}
                            </div>
                            <div className="col-md-6 col-xs-6" style={{ marginBottom: '25px' }}>
                                {this.renderFontPicker({ level: LEVELS.NORMAL })}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 offset-lg-1 col-xs-12 col-sm-8">
                        <div className="row">
                            <div className="col-md-6 col-xs-6" style={{marginBottom: '25px'}}>
                                {this.renderBackgroundPicker({
                                    level: LEVELS.HOVER,
                                    title: TITLES.BACKGROUND
                                })}
                            </div>
                            <div className="col-md-6 col-xs-6" style={{marginBottom: '25px'}}>
                                {this.renderFontPicker({ level: LEVELS.HOVER })}
                            </div>
                        </div>
                    </div>
                    {this.props.layer === 'primary' && (
                        <div className="col-lg-3 offset-lg-1 col-xs-12 col-sm-8">
                            <div className={'row'}>
                                <div className="col-md-6 col-xs-6" style={{marginBottom: '25px'}}>
                                    {this.renderBackgroundPicker({
                                        level: LEVELS.ACTIVE,
                                        title: TITLES.BACKGROUND
                                    })}
                                </div>
                                <div className="col-md-6 col-xs-6" style={{marginBottom: '25px'}}>
                                    {this.renderFontPicker({ level: LEVELS.ACTIVE })}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <FontConfigurator
                    fontFamilyProperty={`buttons.button.${this.props.layer}.font`}
                    fontWeightProperty={`buttons.button.${this.props.layer}.weight`}
                >
                    <div className="col-lg-1 col-xs-12 col-sm-10">
                        <FontPropertySelect
                            label="SIZE"
                            defaultValue={fontSize3}
                            isDisabled={this.props.isDisabled}
                            values={this.props.availableFontSizes}
                            onChange={this.props.onFontSizeChange(this.props.layer, this.props.tagName)}
                        />
                    </div>
                    <div className="col-lg-1 col-xs-12 col-sm-8"></div>
                    <div className="col-lg-4 col-xs-12 col-sm-8">
                        LOADING ICON
                        <div className="row">
                            <span className="col-sm-4"> COLOR 1 </span>
                            <span className="col-sm-4 offset-sm-1"> COLOR 2 </span>
                        </div>
                        <div className="row">
                            <span className="col-sm-4">
                                <PresetColorPicker
                                    color={this.props.data.spinner.color1}
                                    isDisabled={this.props.isDisabled}
                                    onColorChange={this.props.onSpinner1ColorChange(
                                        this.props.layer,
                                        this.props.tagName
                                    )}
                                />
                            </span>
                            <span className="col-sm-4 offset-sm-1">
                                <PresetColorPicker
                                    color={this.props.data.spinner.color2}
                                    isDisabled={this.props.isDisabled}
                                    onColorChange={this.props.onSpinner2ColorChange(
                                        this.props.layer,
                                        this.props.tagName
                                    )}
                                />
                            </span>
                        </div>
                    </div>
                </FontConfigurator>
                <div className="row">
                    <div className="col-lg-2 col-xs-12 col-sm-8">
                        <FontPropertySelect
                            label="TEXT-TRANSFORM"
                            defaultValue={this.props.data.textTransform}
                            isDisabled={this.props.isDisabled}
                            values={['uppercase', 'lowercase', 'capitalize', 'none']}
                            onChange={this.props.onTextTransformChange(this.props.layer, this.props.tagName)}
                        />
                    </div>
                    <div className="col-lg-2 col-xs-12 col-sm-8">
                        <FontPropertySelect
                            label="BORDER RADIUS"
                            defaultValue={borderRadius3}
                            isDisabled={this.props.isDisabled}
                            values={this.props.availableBorderRadius}
                            onChange={this.props.onThemePropChange(`${this.props.layer}.borderRadius`)}
                        />
                        <div className="col-lg-6 col-xs-12 col-sm-8"></div>
                    </div>
                    <div className="spark-panel__content col-lg-12 col-xs-12 col-sm-6">
                        <h4>Border</h4>
                        <h6>Normal</h6>
                        <div className="row">
                            <div className="ThemeColorRow col-lg-2 col-sm-1">
                                <FontPropertySelect
                                    label="Width"
                                    defaultValue={borderNormal[0]}
                                    isDisabled={this.props.isDisabled}
                                    values={this.props.availableBorderRadius}
                                    onChange={this.props.onBorderUpdate(borderNormal, this.props.layer, 'normal', 0)}
                                />
                            </div>
                            <div className="ThemeColorRow col-lg-2 col-sm-1">
                                <FontPropertySelect
                                    label="Style"
                                    defaultValue={borderNormal[1]}
                                    isDisabled={this.props.isDisabled}
                                    values={[
                                        'solid',
                                        'dotted',
                                        'dashed',
                                        'double',
                                        'groove',
                                        'ridge',
                                        'inset',
                                        'outset',
                                        'none',
                                        'hidden'
                                    ]}
                                    onChange={this.props.onBorderUpdate(borderNormal, this.props.layer, 'normal', 1)}
                                />
                            </div>
                            <div className="ThemeColorRow col-lg-2 col-sm-1">
                                <div>Color</div>
                                <div>
                                    <PresetColorPicker
                                        color={borderNormal[2]}
                                        isDisabled={this.props.isDisabled}
                                        onColorChange={this.props.onBorderUpdate(
                                            borderNormal,
                                            this.props.layer,
                                            'normal',
                                            2
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                        <h6>Hover</h6>
                        <div className="row">
                            <div className="ThemeColorRow col-lg-2 col-sm-1">
                                <FontPropertySelect
                                    label="Width"
                                    defaultValue={borderHover[0]}
                                    isDisabled={this.props.isDisabled}
                                    values={this.props.availableBorderRadius}
                                    onChange={this.props.onBorderUpdate(borderHover, this.props.layer, 'hover', 0)}
                                />
                            </div>
                            <div className="ThemeColorRow col-lg-2 col-sm-1">
                                <FontPropertySelect
                                    label="Style"
                                    defaultValue={borderHover[1]}
                                    isDisabled={this.props.isDisabled}
                                    values={[
                                        'solid',
                                        'dotted',
                                        'dashed',
                                        'double',
                                        'groove',
                                        'ridge',
                                        'inset',
                                        'outset',
                                        'none',
                                        'hidden'
                                    ]}
                                    onChange={this.props.onBorderUpdate(borderHover, this.props.layer, 'hover', 1)}
                                />
                            </div>
                            <div className="ThemeColorRow col-lg-2 col-sm-1">
                                <div>Color</div>
                                <div>
                                    <PresetColorPicker
                                        color={borderHover[2]}
                                        isDisabled={this.props.isDisabled}
                                        onColorChange={this.props.onBorderUpdate(
                                            borderHover,
                                            this.props.layer,
                                            'hover',
                                            2
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                        {this.props.layer === 'primary' ? (
                            <div>
                                <h6>Active</h6>
                                <div className="row">
                                    <div className="ThemeColorRow col-lg-2 col-sm-1">
                                        <FontPropertySelect
                                            label="Width"
                                            defaultValue={borderActive[0]}
                                            isDisabled={this.props.isDisabled}
                                            values={this.props.availableBorderRadius}
                                            onChange={this.props.onBorderUpdate(
                                                borderActive,
                                                this.props.layer,
                                                'active',
                                                0
                                            )}
                                        />
                                    </div>
                                    <div className="ThemeColorRow col-lg-2 col-sm-1">
                                        <FontPropertySelect
                                            label="Style"
                                            defaultValue={borderActive[1]}
                                            isDisabled={this.props.isDisabled}
                                            values={[
                                                'solid',
                                                'dotted',
                                                'dashed',
                                                'double',
                                                'groove',
                                                'ridge',
                                                'inset',
                                                'outset',
                                                'none',
                                                'hidden'
                                            ]}
                                            onChange={this.props.onBorderUpdate(
                                                borderActive,
                                                this.props.layer,
                                                'active',
                                                1
                                            )}
                                        />
                                    </div>
                                    <div className="ThemeColorRow col-lg-2 col-sm-1">
                                        <div>Color</div>
                                        <div>
                                            <PresetColorPicker
                                                color={borderActive[2]}
                                                isDisabled={this.props.isDisabled}
                                                onColorChange={this.props.onBorderUpdate(
                                                    borderActive,
                                                    this.props.layer,
                                                    'active',
                                                    2
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    };
}

ButtonStyles.propTypes = {
    children: PropTypes.element,
    settings: PropTypes.object,
    tagNameName: PropTypes.string
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...state.app.data.theme.buttons[ownProps.layer][ownProps.tagName],
        ...state.theme.buttons,
        themeColors: state.app.data.theme.colors,
        availableFontFamilies: state.theme.fonts
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFontSizeChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_FONT_SIZE,
                    layer: layer,
                    target: target,
                    size: event.target.value
                });
        },
        onFontColorChange: (layer, target, level) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_FONT_COLOR,
                    layer: layer,
                    target: target,
                    color: event.target.value,
                    level: level
                });
        },
        onBackgroundColorChange: (layer, target, level) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_BACKGROUND_COLOR,
                    layer: layer,
                    target: target,
                    color: event.target.value,
                    level: level
                });
        },
        onSpinner1ColorChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_SPINNER1_COLOR,
                    layer: layer,
                    target: target,
                    color: event.target.value
                });
        },
        onTextTransformChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_TEXT_TRANSFORM,
                    layer: layer,
                    target: target,
                    textTransform: event.target.value
                });
        },
        onSpinner2ColorChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_SPINNER2_COLOR,
                    layer: layer,
                    target: target,
                    color: event.target.value
                });
        },
        onTextAlignChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_TEXT_ALIGN,
                    layer: layer,
                    target: target,
                    align: event.target.value
                });
        },
        onBorderUpdate: (border, layer, type, index) => {
            const value = border;
            return event => {
                value[index] = event.target.value;
                return dispatch(ThemeActions.modifyThemeKey(`${prefix}.${layer}.border.${type}`, value.join(' ')));
            };
        },
        onThemePropChange: onThemePropChange(dispatch, prefix)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ButtonStyles);



// WEBPACK FOOTER //
// ./src/components/pages/theme/buttons/Styles.js